module.exports = __webpack_public_path__ + "img/BigWaterfall.b2ebb9e5.gif";